export enum VariableType {
    VAR_CHAR = 1,
    NUMERIC,
    DATE_TIME,
    INTEGER,
}
